<template>
  <div class="products">
    <!-- Hero Section -->
    <div class="hero-section">
      <div class="hero-content">
        <div class="hero-text">
          <h1>产品服务</h1>
          <p>融合AI数字人与AIGC前沿科技</p>
          <p>华视致力于赋能干行百业，构建一个多元化的数字人应用生态</p>
        </div>
        <div class="hero-image">
          <img src="https://huashi-ai.oss-cn-wuhan-lr.aliyuncs.com/project-shuke/image/top.png" alt="AI产品服务" class="ai-character" />
        </div>
      </div>
    </div>
    
    <!-- 数字人形象定制系统 -->
    <div id="digital-human" class="digital-human-section">
      <div class="container">
        <!-- 导航栏 -->
        <div class="nav-bar">
          <div 
            class="nav-item" 
            :class="{ active: activeNavItem === 'digital-human' }"
            @click="setActiveNavItem('digital-human')">
            数字人形象定制
          </div>
          <div 
            class="nav-item" 
            :class="{ active: activeNavItem === 'video-service' }"
            @click="setActiveNavItem('video-service')">
            数字人短视频
          </div>
          <div 
            class="nav-item" 
            :class="{ active: activeNavItem === 'interaction-system' }"
            @click="setActiveNavItem('interaction-system')">
            数字人交互系统
          </div>
          <div 
            class="nav-item" 
            :class="{ active: activeNavItem === 'aigc-video' }"
            @click="setActiveNavItem('aigc-video')">
            AIGC视频
          </div>
          <div 
            class="nav-item" 
            :class="{ active: activeNavItem === 'ai-secretary' }"
            @click="setActiveNavItem('ai-secretary')">
            AI随身秘书
          </div>
        </div>
        
        <!-- 主要内容区域 -->
        <div class="main-content">
          <!-- 顶部标题区域 -->
          <div class="title-section">
            <div class="main-title">
              <h2>【你的品牌数字分身】</h2>
              <h1>闪宝-数字人形象定制系统</h1>
            </div>
            <div class="tagline">
              <p>形象复刻·动画渲染·行业覆盖·数字资产</p>
            </div>
          </div>
          
          <!-- 中间内容区域 -->
          <div class="content-middle">
            <img src="@/assets/image/products/shanbao1.png" alt="闪宝数字人形象定制系统" class="main-image">
          </div>
          
          <!-- 底部描述 -->
          <div class="description-section">
            <p>IP形象定制系统,是一款专业数字人IP形象定制服务,基于高精度3D建模、骨骼绑定与动画渲染,结合AI与真人复刻技术,为您打造高度拟人化、可灵活运用于多场景的虚拟形象。IP形象一次制作,长期复用,显著降低真人拍摄与重复制作成本,高效赋能品牌视觉表达与数字资产积累。</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 数字人短视频服务 -->
    <div id="video-service" class="video-service-section">
      <div class="container">
        <!-- 顶部标题区域 -->
        <div class="video-title-section">
          <div class="video-main-title">
            <h2>【你的视频生成大师】</h2>
            <h1>闪宝-数字人短视频服务</h1>
          </div>
        </div>
        
        <!-- 卡片内容区域 -->
        <div class="cards-container">
          <div 
            v-for="card in cards" 
            :key="card.id"
            class="service-card" 
            :class="selectedCard === card.id ? card.id + '-card large' : 'policy-card small'"
            @click="selectCard(card.id)"
            @dblclick="showModal(card.modalImage)">
            
            <!-- 大卡片内容 -->
            <div v-if="selectedCard === card.id" class="card-image-section">
              <div class="image-background">
                <h3>{{ card.title }}</h3>
                <div class="digital-human-figure">
                  <!-- 这里可以放置数字人形象图片 -->
                </div>
                <div class="laptop-hologram">
                  <!-- 这里可以放置笔记本电脑和全息投影效果 -->
                </div>
              </div>
            </div>
            <div v-if="selectedCard === card.id" class="card-description">
              <p>{{ card.content }}</p>
            </div>
            
            <!-- 小卡片内容 -->
            <div v-if="selectedCard !== card.id">
              <h3>{{ card.title }}</h3>
              <div class="character-image">
                <img :src="card.smallImage" :alt="card.title" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 数字人交互系统 -->
    <div id="interaction-system" class="interaction-system-section">
      <div class="container">
        <!-- 顶部功能标签 -->
        <div class="function-tags">
          智能客服·政务导办·接待讲解·电商导购
        </div>
        
        <!-- 主要内容区域 -->
        <div class="interaction-content">
          <!-- 左侧图片区域 -->
          <div class="left-image-section">
            <img src="@/assets/image/products/shanbao-left.png" alt="闪宝数字人交互系统" class="main-interaction-image">
          </div>
          
          <!-- 右侧内容区域 -->
          <div class="right-content-section">
            <!-- 标题 -->
            <div class="interaction-title">
              <h2>【你的多语智能助手】</h2>
              <h1>闪宝-数字人交互系统</h1>
            </div>
            
            <!-- 功能特性按钮 -->
            <div class="feature-buttons">
              <div class="feature-button">多语种实时交互</div>
              <div class="feature-button">大模型精准应答</div>
              <div class="feature-button">拟人化语音</div>
              <div class="feature-button">全终端部署</div>
            </div>
            
            <!-- 描述文字 -->
            <div class="interaction-description">
              <p>AI数字人交互系统,是基于自然语言处理(NLP)、语音识别与合成、以及大模型技术的AI数字人交互系统,支持方言与多语种实时语音互动。</p>
              <p>系统可部署于手机、电脑、大屏等多种终端,提供拟人化语音对话、精准问答与业务引导,实现7x24小时智能服务。</p>
            </div>
            <div class="bottom-tags">
              <div class="tagline">
                <p>智能客服·政务导办·接待讲解·电商导购</p>
              </div>
            </div>
          </div>
        </div>
        
      
      </div>
    </div>

    <!-- 数字人短视频服务 - AI屏形机器人 -->
    <div id="aigc-video" class="ai-screen-robot-section">
      <div class="container">
        <div class="ai-robot-content">
          <!-- 左侧内容区域 -->
          <div class="left-content">
            <div class="ai-robot-title">
              <h2>【你的视频生成大师】</h2>
              <h1>闪宝-数字人短视频服务</h1>
            </div>
            
            <!-- 功能特性按钮 -->
            <div class="feature-buttons">
              <div class="feature-button">灵活部署</div>
              <div class="feature-button">自主巡航</div>
              <div class="feature-button">拟人交互</div>
              <div class="feature-button">多功能集成</div>
            </div>
            
            <!-- 描述文字 -->
            <div class="ai-description">
              <p>AI屏形机器人,采用工业级透明OLED面板,透光率达45%,支持1080P高清显示,底盘采用SLAM (同步定位与地图构建)技术,具备自主导航和避障能力,摆脱固定位置限制,变"被动应答"为"主动迎宾"。</p>
              <p>通过AI语音交互和移动电源管理,实现全流程智能化引导,包括AR导航、实时互动、实时信息推送,是移动的广告牌和信息站。</p>
            </div>
            
            <div class="tagline">
              <p>会展活动・政务/银行・酒店/文旅・医疗健康・教育科研</p>
            </div>
          </div>
          
          <!-- 右侧图片区域 -->
          <div class="right-image-section">
            <img src="@/assets/image/products/video.png" alt="闪宝数字人短视频服务" class="ai-robot-image">
          </div>
        </div>
      </div>
    </div>


    <!-- AIGC视频生成系统 -->
    <div id="ai-secretary" class="aigc-video-section">
      <div class="container">
        <div class="aigc-content">
          <!-- 左侧图片区域 -->
          <div class="aigc-left-image-section">
            <div class="aigc-function-tags">
              <div class="aigc-tag">文本生成视频</div>
              <div class="aigc-tag">图像驱动风格</div>
              <div class="aigc-tag">2D/3D数字人</div>
              <div class="aigc-tag">多语种适配</div>
            </div>
            <img src="https://huashi-ai.oss-cn-wuhan-lr.aliyuncs.com/project-shuke/image/bottom.png" alt="AIGC视频生成系统" class="aigc-main-image">
          </div>
          
          <!-- 右侧内容区域 -->
          <div class="aigc-right-content-section">
            <!-- 标题 -->
            <div class="aigc-title">
              <h2>【你的多语智能助手】</h2>
              <h1>闪宝-数字人交互系统</h1>
            </div>
            
            <!-- 描述文字 -->
            <div class="aigc-description">
              <p>AIGC视频生成系统,是一款智能视频生成系统,能够通过文本、图像或视频参考,快速生成逻辑清晰、画面精美、电影级的视频内容。</p>
              <p>系统融合3D/2D数字人生成、真人复刻、多语种适配等AI能力,支持虚实结合的视频制作,大幅降低拍摄成本,提升内容产出效率。</p>
            </div>
              
            <div class="tagline">
              <p>电影级特效・无需实拍・快速出片・覆盖多行业</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 模态框 -->
    <div v-if="showImageModal" class="modal-overlay" @click="closeModal">
      <div class="modal-content" @click.stop>
        <button class="close-btn" @click="closeModal">&times;</button>
        <img :src="modalImageSrc" :alt="modalImageAlt" class="modal-image" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Products',
  data() {
    return {
      showImageModal: false,
      modalImageSrc: '',
      modalImageAlt: '',
      selectedCard: 'knowledge', // 默认选中知识科普卡片
      activeNavItem: 'digital-human', // 默认选中数字人形象定制
      serviceImages: {
        service1: {
          src: require('@/assets/image/products/service1.png'),
          alt: '政策解读大图'
        },
        service2: {
          src: require('@/assets/image/products/service2.png'),
          alt: '产品介绍大图'
        },
        service3: {
          src: require('@/assets/image/products/service3.png'),
          alt: '矩阵打造大图'
        }
      },
      cards: [
        {
          id: 'knowledge',
          title: '知识科普',
          content: '作为智能知识载体,将复杂的专业知识、前沿科技动态或教育课程内容,通过高度拟人化的表达和视觉化的呈现,转化为易于理解的短视频形式。不仅极大地提升了信息传达的效率和趣味性,还能有效降低学习门槛,促进知识的广泛传播与深度吸收,尤其在职业培训、技能提升及前沿科学普及方面展现出显著优势。',
          smallImage: 'https://huashi-ai.oss-cn-wuhan-lr.aliyuncs.com/project-shuke/image/products-1.png',
          largeImage: 'https://huashi-ai.oss-cn-wuhan-lr.aliyuncs.com/project-shuke/image/service1.png',
          modalImage: 'service1'
        },
        {
          id: 'policy',
          title: '政策解读',
          content: '在政府机构及公共服务领域，数字人短视频可作为权威的政策信息发布渠道。通过构建具备专业素养和亲和力的数字形象，对国家政策、法律法规、行业标准进行精准、全面、系统化的解读。这有助于消除信息壁垒确保政策精神的准确传达，提升公众对政策的理解度与执行力，从而优化公共服务效率和政府治理能力。',
          smallImage: 'https://huashi-ai.oss-cn-wuhan-lr.aliyuncs.com/project-shuke/image/products-2.png',
          largeImage: 'https://huashi-ai.oss-cn-wuhan-lr.aliyuncs.com/project-shuke/image/service2.png',
          modalImage: 'service1'
        },
        {
          id: 'product',
          title: '产品介绍',
          content: '在商业营销中能够以虚拟代言人或智能导购的身份，对产品的功能特性技术优势、设计理念和应用场景进行多维度、沉浸式的展示。通过拟真实的用户体验和互动场景，数字人能有效构建与消费者之间的情感连接显著提升产品的市场吸引力、品牌认知度及销售转化率。',
          smallImage: 'https://huashi-ai.oss-cn-wuhan-lr.aliyuncs.com/project-shuke/image/products-3.png',
          largeImage: 'https://huashi-ai.oss-cn-wuhan-lr.aliyuncs.com/project-shuke/image/service3.png',
          modalImage: 'service2'
        },
        {
          id: 'matrix',
          title: '矩阵打造',
          content: '对于企业而言，数字人短视频提供了一种革命性的内容生产模式。通过标准化、模块化的数字人生成技术，企业能够以极低的成本和极高的效率，批量创作定制化的短视频内容，并迅速部署至多平台媒体矩阵。不仅保障了品牌形象和信息传递的统一性，更实现了内容生产的工业化和规模化，赋能企业快速响应市场变化，实现用户触达的指数级增长和品牌声量的持续放大。',
          smallImage: 'https://huashi-ai.oss-cn-wuhan-lr.aliyuncs.com/project-shuke/image/products-4.png',
          largeImage: 'https://huashi-ai.oss-cn-wuhan-lr.aliyuncs.com/project-shuke/image/service4.png',
          modalImage: 'service3'
        }
      ]
    }
  },
  methods: {
    selectCard(cardType) {
      this.selectedCard = cardType
    },
    setActiveNavItem(item) {
      this.activeNavItem = item
      // 滚动到对应的内容区域
      this.scrollToSection(item)
    },
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId)
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      }
    },
    showModal(serviceType) {
      const service = this.serviceImages[serviceType]
      if (service) {
        this.modalImageSrc = service.src
        this.modalImageAlt = service.alt
        this.showImageModal = true
        document.body.style.overflow = 'hidden' // 防止背景滚动
      }
    },
    closeModal() {
      this.showImageModal = false
      document.body.style.overflow = 'auto' // 恢复滚动
    }
  }
}
</script>

<style scoped>
.products {
  min-height: 100vh;
  background-color: #f8f9fa;
}

/* Hero Section */
.hero-section {
  background: linear-gradient(#93BEEB 0%, #F0F7FD 100%);
  position: relative;
  overflow: hidden;
}

.hero-content {
  margin-left: 15%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 2;
  min-height: 400px;
}

.hero-text {
  flex: 1;
  max-width: 40%;
  position: relative;
  z-index: 10;
}

.hero-text h1 {
  color: #2c3e50;
  margin-bottom: 20px;
  width: 256px;
  height: 84px;

  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 700;
  font-size: 64px;
  line-height: 84px;
  color: #222222;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.hero-text p {
  font-size: 1.2rem;
  color: #2c3e50;
  line-height: 1.6;
  max-width: 500px;
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 400;
  font-size: 28px;
  color: #333333;
  white-space: nowrap;
  overflow: visible;
  margin-bottom: 10px;
  position: relative;
  z-index: 11;

  flex: none;
  order: 1;
  flex-grow: 0;
}

.hero-image {
  position: relative;
  height: 400px;
  flex-shrink: 0;
  z-index: 1;
}

.ai-character {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
  transform: scaleX(-1);
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 数字人形象定制系统样式 */
.digital-human-section {
  padding: 40px 0;
  margin-top: 20px;
  border-radius: 20px;
}

.nav-bar {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

.nav-item {
  color: #999999;
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
  padding: 12px 0px 0px;
  width: 90px;
  height: 44px;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex: none;
  order: 0;
  flex-grow: 0;
  white-space: nowrap;
}

.nav-item:hover {
  background: rgba(255, 255, 255, 0.3);
}

.nav-item.active {
  color: #045FB2;
  width: 105px;
  height: 44px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  position: relative;
}

.nav-item.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 2px;
  background-color: #045FB2;
  border-radius: 1px;
}

.main-content {
  background: white;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  background: linear-gradient(#96C0EC 0%, #8DA4FF 100%);
  color: white;
}

.title-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 40px;
  flex-wrap: wrap;
}

.main-title h2 {
  font-size: 1.2rem;
  color: white;
  font-weight: 500;
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 290;
  font-size: 36px;
  line-height: 48px;
  margin-left: -20px;
}

.main-title h1 {
  color: white;
  margin: 0;
  font-weight: 700;
  /* 闪宝-数字人形象定制系统 */
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-size: 36px;
  line-height: 48px;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.3);
}

.tagline p {
  font-size: 1rem;
  color: white;
  margin: 0;
  font-weight: 500;

  /* Button */

box-sizing: border-box;

/* Auto layout */
display: flex;
flex-direction: row;
justify-content: center;
align-items: center;
padding: 11px 26px;
gap: 10px;

border: 1px solid #0D1B27;
border-radius: 20px;
/* Watch the demo */

font-family: 'Microsoft YaHei';
font-style: normal;
font-weight: 700;
font-size: 16px;
line-height: 24px;
/* identical to box height, or 150% */
display: flex;
align-items: center;
text-align: center;
letter-spacing: 0.1em;

color: #293A49;


/* Inside auto layout */
flex: none;
order: 1;
flex-grow: 0;

}

.content-middle {
  margin-bottom: 40px;
  text-align: center;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
}

.main-image {
  height: auto;
  object-fit: cover;
}

.description-section {
  padding: 30px;
  border-radius: 15px;
}

.description-section p {
  color: white;
  line-height: 1.8;
  font-size: 1rem;
  margin: 0;
}

/* 数字人短视频服务样式 */
.video-service-section {
  padding: 60px 0;
  background: #f8f9fa;
}

.video-title-section {
  text-align: center;
  margin-bottom: 50px;
}

.video-main-title h2 {
  font-size: 1.2rem;
  color: #2c3e50;
  font-weight: 500;
  font-family: 'Microsoft YaHei';
  margin-bottom: 10px;
}

.video-main-title h1 {
  color: #2c3e50;
  margin: 0;
  font-weight: 700;
  font-family: 'Microsoft YaHei';
  font-size: 2.5rem;
  line-height: 1.2;
}

.cards-container {
  display: flex;
  gap: 30px;
  max-width: 1400px;
  margin: 0 auto;
  justify-content: center;
}

/* 统一的服务卡片样式 */
.service-card {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  box-shadow: 5px 4px 15px rgba(0, 0, 0, 0.4) ;
}

.service-card:hover {
  transform: translateY(-5px);
}

/* 大卡片样式 */
.knowledge-card.large,
.policy-card.large,
.product-card.large,
.matrix-card.large {
  width: 600px;
  height: 440px;
  flex-shrink: 0;
  color: white;
}

/* 小卡片样式 */
.policy-card.small {
  flex-shrink: 0;
  background: linear-gradient(180deg, #4a5568 0%, #2d3748 100%);
  color: white;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 30px;
  position: relative;
  max-width: 220px;
  height: 440px;
  padding: 30px 0;
  /* 整体变灰 */
  filter: grayscale(100%);
}

.card-image-section {
  position: relative;
  height: 300px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

/* 不同卡片的背景图片 - 使用动态类名 */
.knowledge-card.large .card-image-section {
  background-image: url('@/assets/image/products/service1.png');
}

.policy-card.large .card-image-section {
  background-image: url('@/assets/image/products/service2.png');
}

.product-card.large .card-image-section {
  background-image: url('@/assets/image/products/service3.png');
}

.matrix-card.large .card-image-section {
  background-image: url('@/assets/image/products/service4.png');
}

.image-background {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
}

.image-background h3 {
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  font-size: 1.5rem;
  font-weight: 700;
  font-family: 'Microsoft YaHei';
  z-index: 2;
}

.digital-human-figure {
  width: 200px;
  height: 250px;
  position: relative;
  z-index: 2;
}

.laptop-hologram {
  width: 200px;
  height: 150px;
  background: linear-gradient(45deg, rgba(255,255,255,0.1), rgba(255,255,255,0.3));
  border-radius: 10px;
  position: relative;
  z-index: 1;
}

@keyframes hologram {
  0%, 100% { opacity: 0.3; }
  50% { opacity: 0.8; }
}

.card-description {
  padding: 30px;
}

.card-description p {
  margin: 0;
  text-align: justify;
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 290;
  font-size: 14px;
  line-height: 25px;
  color: #000;
  letter-spacing: 0.05em;
}

/* 小卡片遮罩效果 */
.policy-card.small::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(360deg, rgba(0, 0, 0, 0.5) 0%, rgba(102, 102, 102, 0.5) 100%);
  border-radius: 30px;
  z-index: 1;
}

/* 叠加一层半透明灰色遮罩，使内容整体更灰暗 */
.policy-card.small::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.25);
  border-radius: 30px;
  z-index: 3;
  pointer-events: none;
}


/* 小卡片标题样式 */
.policy-card.small h3 {
  position: relative;
  padding-top: 40px;
  font-family: 'Microsoft YaHei';
  z-index: 2;
}

.service-card h3 {
  color: white;
  font-size: 1.4rem;
  font-weight: 700;
  font-family: 'Microsoft YaHei';
  margin: 0 0 20px 0;
}

/* 统一的character-image样式 */
.character-image {
  height: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.character-image img {
  object-fit: cover;
  border-radius: 10px;
}


@keyframes shimmer {
  0%, 100% { transform: translateX(-100%); }
  50% { transform: translateX(100%); }
}

/* 模态框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease;
}

.modal-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
  background: white;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: scaleIn 0.3s ease;
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 20px;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 24px;
  cursor: pointer;
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: rgba(0, 0, 0, 0.8);
  transform: scale(1.1);
}

.modal-image {
  width: 100%;
  height: auto;
  max-height: 80vh;
  object-fit: contain;
  display: block;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes scaleIn {
  from { 
    opacity: 0;
    transform: scale(0.8);
  }
  to { 
    opacity: 1;
    transform: scale(1);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .hero-content {
    flex-direction: column;
    text-align: center;
    margin-left: 5%;
    padding: 20px 0;
  }
  
  .hero-text {
    max-width: 100%;
    margin-bottom: 20px;
  }
  
  .hero-text h1 {
    font-size: 2.5rem;
    width: auto;
  }
  
  .hero-text p {
    white-space: normal;
    max-width: 100%;
  }
  
  .hero-image {
    width: 250px;
    height: 300px;
    margin-top: 30px;
    margin-left: 0;
  }
  
  .nav-bar {
    gap: 15px;
  }
  
  .nav-item {
    font-size: 0.9rem;
    padding: 6px 12px;
  }
  
  .main-content {
    padding: 20px;
  }
  
  .title-section {
    flex-direction: column;
    gap: 20px;
  }
  
  .main-title h1 {
    font-size: 1.8rem;
  }
  
  .main-image {
    border-radius: 10px;
  }

  .video-main-title h1 {
    font-size: 2rem;
  }

  .cards-container {
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }

  .service-card {
    width: 90%;
    max-width: 400px;
  }
  .image-background {
    flex-direction: column;
    padding: 20px;
  }

  .digital-human-figure {
    width: 150px;
    height: 200px;
    margin-bottom: 20px;
  }

  .laptop-hologram {
    width: 150px;
    height: 100px;
  }

  .character-image {
    height: 200px;
  }

  .service-card h3 {
    font-size: 1rem;
  }

  .interaction-content {
    flex-direction: column;
    gap: 30px;
    padding: 20px;
  }

  .interaction-title h1 {
    font-size: 1.8rem;
  }

  .feature-buttons {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .bottom-tags {
    margin-top: 40px;
    flex-direction: column;
    text-align: center;
  }

  .bottom-function-tags {
    justify-content: center;
    flex-wrap: wrap;
  }
}

@media (max-width: 480px) {
  .hero-text h1 {
    font-size: 2rem;
  }
  
  .hero-text p {
    font-size: 1rem;
    white-space: normal;
  }
  
  .hero-image {
    width: 200px;
    height: 250px;
  }
}

/* 数字人交互系统样式 */
.interaction-system-section {
  padding: 80px 0;
}

.function-tags {
  margin-left: 30px;
  margin-top: 3px;
  position: absolute;
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.1em;
  color: #293A49;
}


.interaction-content {
  display: flex;
  align-items: center;
  gap: 60px;
  max-width: 1400px;
  margin: 0 auto;
  background: white;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  background-image: linear-gradient(#FDF7EF, transparent);
}

.left-image-section {
  text-align: center;
}

.main-interaction-image {
  max-width: 150%;
  height: auto;
  border-radius: 15px;
}

.right-content-section {
  margin-right: 40px;
  padding-left: 80px;
  min-width: 520px;
}

.interaction-title h2 {
  color: #2c3e50;
  font-weight: 500;
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 290;
  font-size: 32px;
  line-height: 43px;
  color: #333333;
  margin-bottom: 10px;
  text-align: end;
}

.interaction-title h1 {
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 700;
  font-size: 36px;
  line-height: 48px;
  letter-spacing: 0.05em;
  color: #000000;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  text-align: end;
}

.feature-buttons {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 30px;
}

.feature-button {
  margin: 20px 40px;
  color: #0460B3;
  padding: 5px 10px;
  border-radius: 10px;
  text-align: center;
  font-size: 0.9rem;
  font-weight: 500;
  font-family: 'Microsoft YaHei';
  border: 1px solid #0460B3;
  border-radius: 6.95455px;
}

.interaction-description p {
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0.1em;
  color: #000000;
}

.bottom-tags {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
  padding: 0 20px;
}

.bottom-tags span:first-child {
  color: #2c3e50;
  font-size: 1rem;
  font-weight: 500;
  font-family: 'Microsoft YaHei';
}

.bottom-function-tags {
  display: flex;
  gap: 20px;
}

.bottom-function-tags span {
  color: #2c3e50;
  font-size: 0.9rem;
  font-weight: 500;
  padding: 5px 12px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 15px;
  border: 1px solid #e0e0e0;
}

/* AI屏形机器人样式 */
.ai-screen-robot-section {
  background: linear-gradient(#ffffff, #D3EBF2);
}

.ai-robot-content {
  display: flex;
  align-items: stretch;
  gap: 60px;
  max-width: 100%;
  min-height: 500px;
  height: auto;
}

.left-content {
  padding:40px 0;
  min-width: 500px;
}

.ai-robot-title h2 {
  color: #2c3e50;
  font-weight: 500;
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 290;
  font-size: 32px;
  line-height: 43px;
  color: #333333;
  margin-bottom: 10px;
}

.ai-robot-title h1 {
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 700;
  font-size: 36px;
  line-height: 48px;
  letter-spacing: 0.05em;
  color: #000000;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  margin-bottom: 30px;
}

.ai-feature-buttons {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-bottom: 30px;
}

.ai-feature-button {
  background: #93BEEB;
  color: #2c3e50;
  padding: 12px 20px;
  border-radius: 20px;
  text-align: center;
  font-size: 0.9rem;
  font-weight: 500;
  font-family: 'Microsoft YaHei';
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #93BEEB;
}

.ai-feature-button:hover {
  background: #7BA7E8;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(147, 190, 235, 0.3);
}

.ai-description {
  margin-bottom: 30px;
}

.ai-description p {
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.05em;
  color: #000000;
  margin-bottom: 15px;
}

.application-scenarios {
  margin-top: 20px;
}

.scenario-tag {
  background: #93BEEB;
  color: #2c3e50;
  padding: 12px 24px;
  border-radius: 20px;
  text-align: center;
  font-size: 0.9rem;
  font-weight: 500;
  font-family: 'Microsoft YaHei';
  border: 1px solid #93BEEB;
  display: inline-block;
  width: 100%;
  box-sizing: border-box;
}

.right-image-section {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-width: 845px;
}

.ai-robot-image {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .ai-robot-content {
    flex-direction: column;
    gap: 30px;
    padding: 20px;
  }
  
  .left-content {
    padding-right: 0;
  }
  
  .ai-robot-title h1 {
    font-size: 1.8rem;
  }
  
  .ai-robot-title h2 {
    font-size: 1.2rem;
  }
  
  .ai-feature-buttons {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  
  .ai-description p {
    font-size: 14px;
  }
}

/* AIGC视频生成系统样式 */
.aigc-video-section {
  padding: 80px 0;
  background: #f8f9fa;
}

.aigc-function-tags {
  margin: 0 0 40px 0;
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.1em;
  color: #293A49;
  gap: 15px;
  flex-wrap: wrap;
  display: flex;
  justify-content: center;
}

.aigc-tag {
  border: 1px solid #0D1B27;
  border-radius: 20px;
  color: #2c3e50;
  padding: 8px 16px;
  border-radius: 5px;
  font-size: 0.9rem;
  font-weight: 500;
  font-family: 'Microsoft YaHei';
  transition: all 0.3s ease;
}

.aigc-tag:hover {
  background: #7BA7E8;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(147, 190, 235, 0.3);
}

.aigc-content {
  display: flex;
  align-items: center;
  gap: 60px;
  max-width: 1400px;
  margin: 0 auto;
  background: white;
  padding: 40px;
  background: #FFFFFF;
  box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.25);
  border-radius: 30px;
}

.aigc-left-image-section {
  text-align: center;
}

.aigc-main-image {
  max-width: 100%;
  height: auto;
  border-radius: 15px;
  min-width: 570px;
}

.aigc-right-content-section {
  min-width: 580px;
}

.aigc-title h2 {
  color: #2c3e50;
  font-weight: 500;
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 290;
  font-size: 32px;
  line-height: 43px;
  color: #333333;
  margin-bottom: 10px;
  text-align: end;
}

.aigc-title h1 {
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 700;
  font-size: 36px;
  line-height: 48px;
  letter-spacing: 0.05em;
  color: #000000;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  text-align: end;
}

.aigc-description p {
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0.1em;
  color: #000000;
  margin: 15px 0;
}
/* 响应式设计 */
@media (max-width: 768px) {
  .aigc-content {
    flex-direction: column;
    gap: 30px;
    padding: 20px;
  }
  
  .aigc-right-content-section {
    padding-left: 0;
    min-width: auto;
  }
  
  .aigc-title h1 {
    font-size: 1.8rem;
  }
  
  .aigc-title h2 {
    font-size: 1.2rem;
  }
  
  .aigc-description p {
    font-size: 16px;
  }
  
  .aigc-function-tags {
    position: relative;
    margin-left: 0;
    justify-content: center;
  }
}
</style>
